import useColorPickerDeleteColor from './useColorPickerDeleteColor';

export default useColorPickerDeleteColor;